export function createInteractionRouterSystem({
  worldInteractSystem,
  tryUseUtility,
  tryStartShieldBlocking,
  tryStartBowCharge,
  tryEquipArmor,
  tryConsumeFood,
  tryScoopFluid,
  tryPourFluid,
  tryPlaceActiveBlock,
  stopMining
} = {}) {
  function handledWithStop(armPlaceRepeat = false) {
    stopMining?.();
    return {
      handled: true,
      armPlaceRepeat
    };
  }

  function handled(armPlaceRepeat = false) {
    return {
      handled: true,
      armPlaceRepeat
    };
  }

  function routeSecondaryInteraction(hit = null) {
    const villagerInteractRange = worldInteractSystem?.getVillagerInteractRangeFromHit?.(hit) ?? 4.5;
    if (worldInteractSystem?.tryOpenVillagerTradeByAim?.(villagerInteractRange)) return handledWithStop();
    if (worldInteractSystem?.tryFeedPassiveMobByAim?.(villagerInteractRange)) return handledWithStop();

    if (worldInteractSystem?.tryOpenCraftingTableByHit?.(hit)) return handled();
    if (worldInteractSystem?.tryOpenFurnaceByHit?.(hit)) return handled();
    if (worldInteractSystem?.tryOpenChestByHit?.(hit)) return handled();

    if (worldInteractSystem?.tryToggleInteractiveBlockByHit?.(hit)) return handledWithStop();
    if (worldInteractSystem?.tryToggleLeverByHit?.(hit)) return handledWithStop();
    if (worldInteractSystem?.tryUseBedByHit?.(hit)) return handledWithStop();

    if (worldInteractSystem?.tryIgnitePortalFromHitFace?.(hit)) return handledWithStop();
    if (worldInteractSystem?.tryIgnitePortalFromObsidianBlock?.(hit)) return handledWithStop();
    if (worldInteractSystem?.tryIgniteFireFromHitFace?.(hit)) return handledWithStop();
    if (worldInteractSystem?.tryActivateEndPortalFromQuartzBlock?.(hit)) return handledWithStop();

    if (worldInteractSystem?.tryUseFarmingOnHit?.(hit)) return handledWithStop();
    if (tryUseUtility?.(hit)) return handledWithStop();
    if (tryStartShieldBlocking?.()) return handledWithStop();
    if (tryStartBowCharge?.()) return handledWithStop();
    if (tryEquipArmor?.()) return handledWithStop();
    if (tryConsumeFood?.()) return handledWithStop();
    if (tryScoopFluid?.(hit)) return handledWithStop();
    if (tryPourFluid?.(hit)) return handledWithStop();

    tryPlaceActiveBlock?.(hit);
    return handled(true);
  }

  function tryRepeatPlace(hit = null) {
    return !!tryPlaceActiveBlock?.(hit);
  }

  return {
    routeSecondaryInteraction,
    tryRepeatPlace
  };
}
